import { createClient } from '@supabase/supabase-js';

let _client = null;

// Fetch config from server at runtime — credentials never enter the bundle
const _ready = (async () => {
  try {
    const res = await fetch('/.netlify/functions/client-config');
    if (!res.ok) throw new Error(`Config fetch ${res.status}`);
    const { supabaseUrl, supabaseAnonKey } = await res.json();
    _client = createClient(supabaseUrl, supabaseAnonKey);
  } catch (err) {
    console.error('[supabase] config load failed:', err);
  }
})();

export const getSupabase = async () => {
  await _ready;
  if (!_client) throw new Error('Supabase unavailable');
  return _client;
};

export const signUp = async (email, password) => {
  const db = await getSupabase();
  const { data, error } = await db.auth.signUp({ email, password });
  if (error) throw error;
  return data;
};

export const signIn = async (email, password) => {
  const db = await getSupabase();
  const { data, error } = await db.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
};

export const resetPassword = async (email) => {
  const db = await getSupabase();
  const { error } = await db.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/settings`,
  });
  if (error) throw error;
};

export const signOut = async () => {
  const db = await getSupabase();
  const { error } = await db.auth.signOut();
  if (error) throw error;
};

export const getSession = async () => {
  const db = await getSupabase();
  const { data: { session } } = await db.auth.getSession();
  return session;
};

export const saveUserData = async (appData) => {
  const db = await getSupabase();
  const { data: { user } } = await db.auth.getUser();
  if (!user) throw new Error('Not authenticated');
  const { error } = await db
    .from('user_data')
    .upsert(
      { user_id: user.id, data: appData, updated_at: new Date().toISOString() },
      { onConflict: 'user_id' },
    );
  if (error) throw error;
};

export const loadUserData = async () => {
  const db = await getSupabase();
  const { data: { user } } = await db.auth.getUser();
  if (!user) throw new Error('Not authenticated');
  const { data, error } = await db
    .from('user_data')
    .select('data, updated_at')
    .eq('user_id', user.id)
    .single();
  if (error && error.code !== 'PGRST116') throw error;
  return data;
};
